import React from "react";
import { Button } from "@/shared/ui/Button";
import { cn } from "@/shared/utils/shadcn";
import { Column } from "@/shared/ui/Blocks";

interface BurgerMenuButtonProps {
  onClick: () => void;
  isOpen: boolean;
  className?: string;
}

function BurgerMenuButton(props: BurgerMenuButtonProps) {
  const { onClick, isOpen, className } = props;
  const lineClass =
    "w-6 h-[2px] bg-black rounded-full transition-all duration-300";

  const openClass = isOpen
    ? "first:rotate-45 first:translate-y-[4px] last:-rotate-45 last:translate-y-[1.5px]"
    : "";

  return (
    <Button variant="ghost" onClick={onClick} className={className}>
      <Column className={cn(!isOpen && "gap-2")}>
        <div className={cn(lineClass, openClass)} />
        <div className={cn(lineClass, openClass)} />
      </Column>
    </Button>
  );
}

export { BurgerMenuButton };
